/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType: string = "menu-default";

export const subHiddenBreakpoint: number = 1440;
export const menuHiddenBreakpoint: number = 768;
export const defaultLocale: string = "en";

export type TLocaceOptions = {
  id: string;
  name: string;
  direction: "ltr" | "rtl";
};
export const localeOptions: TLocaceOptions[] = [
  { id: "en", name: "English - LTR", direction: "ltr" },
  { id: "es", name: "Español", direction: "ltr" },
  { id: "enrtl", name: "English - RTL", direction: "rtl" },
];

export const searchPath: string = "/app/pages/search";
export const servicePath: string = "https://api.coloredstrategies.com";

export const awsRegion: string = "us-east-1";

// dev
export type TCognitoConfig = {
  UserPoolId: string;
  ClientId: string;
};
export const cognitoConfig: TCognitoConfig = {
  UserPoolId: "us-east-1_tHpDUmzBu",
  ClientId: "6bl5v103snuaql4jiutp3qv5vi",
};

/*
Color Options:
"light.purple", "light.blue", "light.green", "light.orange", "light.red", "dark.purple", "dark.blue", "dark.green", "dark.orange", "dark.red"
*/
export const isMultiColorActive: boolean = false;
export const defaultColor: string = "tumeke.light";
export const defaultDirection: string = "ltr";
export const isDarkSwitchActive: boolean = true;
export const themeColorStorageKey: string = "__theme_color";
export const themeRadiusStorageKey: string = "__theme_radius";
export const isDemo: boolean = false;
